import { AfterViewChecked, AfterViewInit, Component, ComponentFactoryResolver, ComponentRef, EventEmitter, Inject, Injector, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogData } from '../../interfaces/dialog-data';
import { DynamicHostDirective } from '../../dynamic-host-directive';
import { ComponentType } from '@angular/cdk/portal';
import { ItemEnvelope } from '../../models/net/envelope/base/item-envelope';
import { ActingProfileTileComponent } from '../fragments/talent-core/acting-profile-tile/acting-profile-tile.component';
import { ComponentDialogResult } from '../../models/app/component-dialog-result';
import { EmbeddableTileComponent } from '../../interfaces/embeddable-tile-component';
import { AppService } from '../../services/app.service';
import { MessageSeverity } from '../../enums/message-severity';
import { SearchRequestEnvelope } from '../../models/net/envelope/search-request-envelope';

@Component({
    selector: 'app-component-dialog',
    templateUrl: './component-dialog.component.html',
    styleUrls: ['./component-dialog.component.css', '../../app.component.css']
})

export class ComponentDialogComponent implements OnInit, AfterViewInit {

    public dialogDataSource: any | undefined;
    public isDataSourceAltered: boolean = false;
    public isPendingChanges: boolean = false;
    public isEditingTitle: boolean = false;
    public isEditingSubtitle: boolean = false;

    private _componentRef: any;

    @Input() public acceptButtonCaption: string = "OK";
    @Input() public closeButtonCaption: string = "CLOSE";
    @Input() public isWarnBeforeCancel: boolean = false;

    @ViewChild(DynamicHostDirective, { static: true }) dynamicHost!: DynamicHostDirective;

    @Output() public titleChanged = new EventEmitter<string>();
    @Output() public subTitleChanged = new EventEmitter<string>();

    public constructor(public appService: AppService,
                       public dialogReference: MatDialogRef<DialogComponent>,
                       private resolver: ComponentFactoryResolver,
                       @Inject(MAT_DIALOG_DATA) public dialogData: any, 
                       private injector: Injector) {
    }

    public ngOnInit(): void { }

    public ngAfterViewInit(): void { }

    public loadComponent(component: any, dialogDataSource: any): void {

        this.dialogDataSource = dialogDataSource;
        const componentFactory = this.resolver.resolveComponentFactory(component);
        const viewContainerRef = this.dynamicHost.viewContainerRef;
        viewContainerRef.clear();

        this._componentRef = viewContainerRef.createComponent(componentFactory);

        (this._componentRef.instance as EmbeddableTileComponent).setDataSource(dialogDataSource, this);

        (this._componentRef.instance as EmbeddableTileComponent).pendingChangesStateChanged.subscribe((isPendingChanges: boolean) => {

            this.isPendingChanges = isPendingChanges;
        });

        (this._componentRef.instance as EmbeddableTileComponent).setAcceptButtonCaption.subscribe((caption: string) => {

            this.acceptButtonCaption = caption;
        });

        (this._componentRef.instance as EmbeddableTileComponent).setCloseButtonCaption.subscribe((caption: string) => {

            this.closeButtonCaption = caption;
        });

        (this._componentRef.instance as EmbeddableTileComponent).closeContainerRequest.subscribe(() => {

            let dialogResult: ComponentDialogResult = new ComponentDialogResult();

            dialogResult.IsAccepted = false;
            dialogResult.IsDataSourceAltered = this.isDataSourceAltered;

            this.dialogReference.close(dialogResult);
        });

        (this._componentRef.instance as EmbeddableTileComponent).setIsDataSourceAltered.subscribe((isAltered: boolean) => {

            this.isDataSourceAltered = isAltered;
        });
    }

    public toggleEditTitle(): void {

        if (this.dialogData.IsHeaderEditable) {

            this.isEditingTitle = !this.isEditingTitle;
        }
    }

    public toggleEditSubtitle(): void {

        if (this.dialogData.IsHeaderEditable) {

            this.isEditingSubtitle = !this.isEditingSubtitle;
        }
    }

    public updateTitle(event: Event): void {

        this.dialogData.Title = (event.target as HTMLInputElement).value;
        this.titleChanged.emit(this.dialogData.Title);

        (this.dialogDataSource as SearchRequestEnvelope).Document.Item.Name = this.dialogData.Title;
    }

    public updateSubtitle(event: Event): void {

        this.dialogData.Subtitle = (event.target as HTMLInputElement).value;
        this.subTitleChanged.emit(this.dialogData.Subtitle);

        (this.dialogDataSource as SearchRequestEnvelope).Document.Item.Description = this.dialogData.Subtitle;
    }

    public confirm = (): void => {

        const result: ComponentDialogResult = new ComponentDialogResult();

        if ((this._componentRef.instance as EmbeddableTileComponent).validateBeforeAccept()) {

            result.IsAccepted = true;
            result.IsDataSourceAltered = this.isDataSourceAltered;
            result.DataSource = this.dialogDataSource;

            this.dialogReference.close(result);
        }
    }

    public cancel = (): void => {

        let dialogResult: ComponentDialogResult = new ComponentDialogResult();

        dialogResult.IsDataSourceAltered = this.isDataSourceAltered;

        this.dialogReference.close(dialogResult);
    }
}
